module.exports = __webpack_public_path__ + "img/32.3ac6c0b7.png";